import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { StyledFileListHeader } from './EntityListHeader.styles';
import { ColumnWidths } from '../../DocumentVault.meta';
import { useIsFolderReadOnly } from '../../hooks/useIsFolderReadOnly';

export const EntityListHeader: React.FC = () => {
  const isFolderReadOnly = useIsFolderReadOnly();

  return (
    <StyledFileListHeader>
      <Box flex={ColumnWidths.Name}>
        <Text variant="tableHeader">Name</Text>
      </Box>

      <Box flex={ColumnWidths.LastModified}>
        <Text variant="tableHeader">{isFolderReadOnly ? 'Created Date' : 'Last Modified'}</Text>
      </Box>

      <Box flex={ColumnWidths.FileSize}>
        <Text variant="tableHeader">File Size</Text>
      </Box>

      <Box flex={ColumnWidths.Actions} />
    </StyledFileListHeader>
  );
};
